import SyncOutlined from "@mui/icons-material/SyncOutlined";
import React from "react";
import { Base } from "ui/Scripts/source/framework/base";
import { Translations } from "ui/Scripts/source/models/translations";
import { ListStateIcon } from "../ListStateIcon/ListStateIcon";

interface IListStateIconFreshProps {
    date: number
}

export const ListStateIconFresh = (props: IListStateIconFreshProps) => {
    if ((Date.now() - props.date) > Base.oneHourInMs) return null;
    return (
        <ListStateIcon
            tooltip={Translations.RecentlyUpdated}
            icon={SyncOutlined}
        />
    );
};
